const scheduledServicesServicesForSchedulingFilterModal = {
  "filter": "FILTROS",
  "clear": "Limpiar Filtros",
  "site": "Sites",
  "groups": "Grupo",
  "place": "Ubicación",
  "area": "Departamentos",
  "company": "Empresa Tercera",
  "equipmentModel": "Tipo de Equipo",
  "frequencies": "Frecuencias",
  "serviceTypes": "Tipos de Servicio",
  "cancel": "CANCELAR",
  "ok": "APLICAR",
  expirationDate: "Fecha de Vencimiento:",
  equipments: 'Equipos',
  noService: 'Servicios no realizados',
  valid: 'Servicios al día',
  overdue: 'Servicios vencidos',
  noServiceHelperText: 'Muestra servicios que aún no han sido realizados',
  validHelperText: 'Muestra servicios que aún no están vencidos (incluye servicios a demanda)',
  overdueHelperText: 'Muestra servicios que ya están vencidos',
  expirationDateHelperText: 'Para servicios al día y vencidos, no influye en los servicios no realizados',
};

export default scheduledServicesServicesForSchedulingFilterModal;